import
{
    QADASHBOARDSCREEN_LOAD,
    QADASHBOARDSCREEN_UNLOAD,
    QADASHBOARDSCREEN_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{
};

const handlers = {
    [QADASHBOARDSCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [QADASHBOARDSCREEN_UNLOAD]: () => initialState,
    [QADASHBOARDSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
